export enum DefaultOrg {
  OrgId = 1,
  Realm = "master",
  FiscalYearForCostPool = "2000"
}
